import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  FormControl,
  FormLabel,
  Heading,
  Flex,
  Tooltip,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom"; // 라우팅을 위한 useNavigate 훅
import { fetchUserInfo, LogIn } from "../api";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate(); // 페이지 이동을 위한 useNavigate 사용
  const location = useLocation();

  const handleLogin = async () => {
    try {
      const data = await LogIn(email, password);
      // JWT 토큰을 로컬 스토리지에 저장
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);
      const userData = await fetchUserInfo();
      localStorage.setItem("nickname", userData.nickname);
      if (userData.agreed_to_terms === false) {
        navigate("/agreement_retroactive", { state: location.state });
      } else {
        const returnTo = location.state?.returnTo;
        const safeReturnTo =
          returnTo?.startsWith("/") && !returnTo.startsWith("//")
            ? returnTo
            : "/answers";

        navigate(safeReturnTo, {
          replace: true,
          state: location.state?.returnState,
        });
      }
    } catch (error) {
      window.confirm(
        "로그인에 실패했습니다. 이메일과 비밀번호를 다시 확인해주세요"
      );
    }
  };

  const handleGuestUse = () => {
    // 로그인을 하지 않고 /answers로 라우팅
    navigate("/answers/new");
  };

  const handleSignup = () => {
    // 회원가입 페이지로 이동
    navigate("/agreement", { state: location.state });
  };

  return (
    <Flex align="center" justify="center" minH="100vh" p="4">
      <Box p="6" rounded="md" shadow="md" width="full" maxW="400px" bg="white">
        <Heading as="h2" mb="6" textAlign="center">
          ibt 연습장 로그인
        </Heading>

        {location.state?.sessionExpired && (
          <Alert status="warning" mb="4">
            <AlertIcon />
            로그인 세션이 만료되었습니다. 작성 중이던 답안은 임시저장되었으며,
            다시 로그인하면 작성 화면으로 돌아갑니다.
          </Alert>
        )}

        {/* 이메일 입력 */}
        <FormControl mb="4">
          <FormLabel>이메일</FormLabel>
          <Input
            type="email"
            placeholder="이메일 입력"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>

        {/* 비밀번호 입력 */}
        <FormControl mb="4">
          <FormLabel>비밀번호</FormLabel>
          <Input
            type="password"
            placeholder="비밀번호 입력"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>

        {/* 로그인 버튼 */}
        <Button colorScheme="blue" width="full" mb="4" onClick={handleLogin}>
          로그인
        </Button>

        {/* 회원가입 이동 버튼 */}
        <Button colorScheme="teal" width="full" mb="4" onClick={handleSignup}>
          회원가입
        </Button>

        {/* 로그인을 하지 않고 사용하기 버튼 */}
        <Tooltip
          label="로그인 하면 답안지를 저장할 수 있어요!"
          aria-label="Tooltip"
        >
          <Button
            colorScheme="green"
            width="full"
            mb="4"
            onClick={handleGuestUse}
          >
            로그인 없이 사용하기
          </Button>
        </Tooltip>
        <Button
          colorScheme="yellow"
          width="full"
          mb="4"
          onClick={() => navigate("/bar-exam")}
        >
          로그인 없이 객관식 풀서비스 보기
        </Button>
        <Button
          colorScheme="yellow"
          variant="outline"
          width="full"
          onClick={() => navigate("/guide")}
        >
          이용 가이드
        </Button>
        <Flex fontSize="sm" color="gray.600" mt="4" justifyContent="center" wrap="wrap" gap="2">
          <Button onClick={() => navigate("/policy")} variant={"ghost"}>
            이용약관
          </Button>
          <Button onClick={() => navigate("/privacy")} variant={"ghost"}>
            개인정보 처리방침
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Login;
